import cloneDeep from 'lodash/cloneDeep'

export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'MARKERS_SET':
      return payload
    case 'MARKER_CREATE':
      let newState = cloneDeep(state)
      newState.push(payload)
      return newState
    case 'MARKER_UPDATE':
      return state.map(item =>
        item.id === payload.id ? { ...item, ...payload } : item
      )
    case 'MARKER_THREED_UPDATE': {
      // findIndex short-circuits; slice copies refs in one pass; in-place index
      // assignment preserves order — one iteration + one allocation vs the old
      // filter (full pass) + spread (second full pass) that also moved the item
      // to the end of the array.
      const idx = state.findIndex(item => item.id === payload.id)
      const updated = { ...payload, isUpdated: true }
      if (idx === -1) return [...state, updated]
      const next = state.slice()
      next[idx] = updated
      return next
    }
    case 'MARKER_THREED_REMOVE_UPDATED_FLAG': {
      // Guard: if nothing has the flag (steady state after first clear), return
      // the same reference so connected components skip re-render entirely.
      if (!state.some(item => item.isUpdated)) return state
      return state.map(item => {
        if (!item.isUpdated) return item
        const { isUpdated, ...rest } = item
        return rest
      })
    }

    case 'MARKER_DELETE':
      if (state.find(item => item.id = payload).mapObj) {
        state.find(item => item.id = payload).mapObj().setMap(null)
      }
      return state.filter(item => item.id !== payload)
    case 'MARKER_DELETE_MULTIPLE':
      return state.filter(marker => payload.indexOf(marker.id) === -1)
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
